<script setup lang="ts">
import {
	carouselButtonStyles,
	type CarouselGenericActionVariants
} from './index';

type Props = {
	variant?: CarouselGenericActionVariants['variant'];
	padding?: CarouselGenericActionVariants['padding'];
	border?: CarouselGenericActionVariants['border'];
	background?: CarouselGenericActionVariants['background'];
};

const props = withDefaults(defineProps<Props>(), {
	variant: 'default',
	padding: 'none',
	border: 'none',
	background: 'transparent'
});
</script>

<template>
	<!-- TODO: alterar pro botão interno do projeto -->
	<button
		:class="
			carouselButtonStyles({
				variant: props.variant,
				padding: props.padding,
				border: props.border,
				background: props.background
			})
		"
	>
		<slot></slot>
	</button>
</template>
